import React, { useEffect, useState } from 'react';
import { Redirect } from "react-router-dom";
import { useCoverLetter } from '../../../context/CoverLetterContext';
import { COOKIE_DOMAIN, COVERLETTER_FINALIZE, COVERLETTER_PERSONALIZE, MEMBERSHIP, MONTHS, POPUP_TYPES } from '../../../constants/constants';
import DraftEditor from '../../common/DraftEditor';
import DatePicker from "react-datepicker";
// import '../../assets/scss/app/cover-letter-screens/letter-form.scss';
import CalendarIcon from "../../../assets/images/calender.svg";
import WpAPI from '../../../WpApi';
import { usePopup } from '../../../context/PopupContext';
import { formatDate, getLetterName, matchParentClass, stripTags } from '../../../helper';
import QuickTips from '../../common/QuickTips';
import jsCookie from 'js-cookie';
import { useUser } from '../../../context/UserContext';
const FormSection = (props) => {
    const [showToolTip, setShowToolTip] = useState(false);
    const [back, setBack] = useState(false);
    const [next, setNext] = useState(false);
    const [redirect2, setRedirect2] = useState(null);
    const [isTabOneActive, setIsTabOneActive] = useState(false);
    const [isTabTwoActive, setIsTabTwoActive] = useState(false);
    const [isTabThreeActive, setIsTabThreeActive] = useState(false);
    const [fromTick, setfromTick] = useState(false);
    const [toTick, settoTick] = useState(false);
    const [summaryTick, setsummaryTick] = useState(false);
    //Show error using this state
    const [error, setError] = useState({});
    const [checkField, setCheckField] = useState('');
    const popup = usePopup();
    const checkedTick = { color: '#0091ff' }
    const {
        from,
        to,
        ques_ans_response,
        qa_steps_initiated,
        generated_count,
        summary,
        modified_date,
        handlers: {
            save,
            update2Preview,
        },
    } = useCoverLetter();
    const { plan, } = useUser();
    const generateBodythruAI = () => {
        popup.show('wait')
        WpAPI.getLetterByAI(ques_ans_response).then(resp => {
            const op = replaceDummy(resp.output)
            update2Preview({ generated_count: generated_count + 1, summary: { ...summary, content: op } }, true)
            save()
            popup.close('wait')

        }).catch((e) => {
            popup.close('wait')
            popup.show('aiwarning', null, () => generateBodythruAI())
        });
        const replaceDummy = (c) => {
            from.fname.length && (c = c.replace('[Your Name]', from.fname))
            to.fname.length && (c = c.replace("[Recipient's Name]", to.fname))
            return c
        }
    }
    const saveForm = (section, data) => {
        switch (section) {
            case 'from':
                const formData = { ...from, ...data }
                update2Preview({ from: formData })
                break;
            case 'to':
                const toData = { ...to, ...data }
                update2Preview({ to: toData })
                break;
            case 'summary':
                update2Preview({ summary: { ...summary, ...data } })
            default:
                break;
        }
        // markComplete(section)
    }
    const removeError = (e) => {
        setError({ ...error, [e.target.name]: "" });
    }
    const fieldFocus = e => {
        setCheckField(e.target.name);
        removeError(e);
    }

    const fieldBlur = e => {
        setCheckField('');
        // update2Preview({},true)
        save()
        markComplete()
    }
    const markComplete = (section) => {
            if( section == 'from' || !section) 
               setfromTick( from.fname.length && from.phone.length && from.addressline1.length && from.email.length)
            if( section == 'to' || !section) 
                settoTick( to.fname.length && to.phone.length && to.addresstoline1.length && to.email.length && to.company.length)
            if( section == 'summary' || !section) 
                setsummaryTick( summary.content.length && summary.date.length)
    }
    const clickOutsideToolTip = (e) => {
        // if (e.target.classList.value != 'editor-head') {
        //     // e.stopPropagation()
        // }
    }

    useEffect(() => {
        (back) && history.pushState(null, COVERLETTER_FINALIZE);
        back && setRedirect2(COVERLETTER_PERSONALIZE)
        if (next) {
            save()
            history.pushState(null, COVERLETTER_FINALIZE);
            if (plan == 'pro') { setRedirect2('/')
            } else {
                WpAPI.setRedirectCookie('/');
                setRedirect2(MEMBERSHIP)
            }
        }
    }, [back, next]);

    useEffect(() => {
        popup.configurePopup(POPUP_TYPES);
    }, []);

    useEffect(() => {
        //Only for first time and content loaded
        qa_steps_initiated && !generated_count && generateBodythruAI()
        qa_steps_initiated && markComplete()
    }, [qa_steps_initiated]);
    useEffect(() => {
        //This will make sure save markcomplete be called only afte save functon called
        qa_steps_initiated && modified_date && markComplete()
    }, [qa_steps_initiated, modified_date]);

    if (redirect2) return <Redirect to={redirect2} />
    return (
        <div className="panel-left">
            <div className="screen-action">
                <button className="round-btn no-round-btn" onClick={() => setBack(!back)}> <i className="arrow-bar-left"></i><span>Edit Answers</span></button>
                <button className="round-btn  active" onClick={() => setNext(!next)}><i className="icon-tick-light"></i><span>Finish</span></button>
            </div>
            <div className="editor-area-outer">
                <div className="editor-area">
                    <div className="editor-head" onClick={() => setIsTabOneActive(!isTabOneActive)}>
                        <div className="editor-title">
                            <div className="title-left">From <i className="icon-tick-with-circle" style={fromTick ? checkedTick : {}}></i> </div>
                            <div className="title-right"><i className={isTabOneActive ? 'icon-arrow icon-arrow-up-light' : 'icon-arrow icon-arrow-down-light'}></i></div>
                        </div>
                        <div className="editor-para">Fill out your contact information, including your email and phone number.</div>
                    </div>
                    {isTabOneActive && <div className="editor-body">
                        <div className="form-row">
                            <div className="field-wrap">
                                <label htmlFor="fname" className={`label${checkField == 'fname' ? ' label-focus' : ''}`}>Full Name</label>
                                <input
                                    type="text"
                                    className="validate"
                                    name="fname"
                                    id="fname"
                                    defaultValue={from.fname}
                                    placeholder='Your Full Name'
                                    onChange={(e) => {
                                        saveForm('from', { fname: stripTags(e.target.value) });
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => fieldBlur(e)}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-wrap">
                                <label htmlFor="phone" className={`label${checkField == 'phone' ? ' label-focus' : ''}`}>Phone</label>
                                <input
                                    type="text"
                                    className="validate"
                                    name="phone"
                                    id="phone"
                                    placeholder="Your Phone Number"
                                    defaultValue={from.phone}
                                    onChange={(e) => {
                                        saveForm('from', { phone: e.target.value });
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => fieldBlur(e)}
                                />
                            </div>
                            <div className="field-wrap">
                                <label htmlFor="email" className={`label${checkField == 'email' ? ' label-focus' : ''}`}>Email Address</label>
                                <input
                                    type="text"
                                    className="validate"
                                    name="email"
                                    id="email"
                                    placeholder="Your Email Address"
                                    defaultValue={from.email}
                                    onChange={(e) => {
                                        saveForm('from', { email: e.target.value });
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => fieldBlur(e)}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-wrap">
                                <label htmlFor="addressline1" className={`label${checkField == 'addressline1' ? ' label-focus' : ''}`}>Address Line 1</label>
                                <input
                                    type="text"
                                    className="validate"
                                    name="addressline1"
                                    id="addressline1"
                                    placeholder="Your Address"
                                    defaultValue={from.addressline1}
                                    onChange={(e) => {
                                        saveForm('from', { addressline1: e.target.value });
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => fieldBlur(e)}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-wrap">
                                <label htmlFor="addressline2" className={`label${checkField == 'addressline2' ? ' label-focus' : ''}`}>Address Line 2</label>
                                <input
                                    type="text"
                                    className="validate"
                                    name="addressline2"
                                    id="addressline2"
                                    placeholder="Your City, State, Zip"
                                    defaultValue={from.addressline2}
                                    onChange={(e) => {
                                        saveForm('from', { addressline2: e.target.value });
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => fieldBlur(e)}
                                />
                            </div>
                        </div>
                    </div>}
                </div>
                <div className="editor-area">
                    <div className="editor-head" onClick={() => setIsTabTwoActive(!isTabTwoActive)}>
                        <div className="editor-title">
                            <div className="title-left">To <i className="icon-tick-with-circle"  style={toTick ? checkedTick : {}}></i> </div>
                            <div className="title-right"><i className={isTabTwoActive ? 'icon-arrow icon-arrow-up-light' : 'icon-arrow icon-arrow-down-light'}></i></div>
                        </div>
                        <div className="editor-para">Address the employer here.</div>
                    </div>
                    {isTabTwoActive && <div className="editor-body">
                        <div className="form-row">
                            <div className="field-wrap">
                                <label htmlFor="fname" className={`label${checkField == 'fname' ? ' label-focus' : ''}`}>Full Name</label>
                                <input
                                    type="text"
                                    className="validate"
                                    name="fname"
                                    id="fname"
                                    placeholder="Hiring Manager's Name (or Hiring Manager if you're not sure)"
                                    defaultValue={to.fname}
                                    onChange={(e) => {
                                        saveForm('to', { fname: stripTags(e.target.value) });
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => fieldBlur(e)}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-wrap">
                                <label htmlFor="phone" className={`label${checkField == 'phone' ? ' label-focus' : ''}`}>Phone</label>
                                <input
                                    type="text"
                                    className="validate"
                                    name="phone"
                                    id="phone"
                                    placeholder="Company Phone Number"
                                    defaultValue={to.phone}
                                    onChange={(e) => {
                                        saveForm('to', { phone: e.target.value });
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => fieldBlur(e)}
                                />
                            </div>
                            <div className="field-wrap">
                                <label htmlFor="email" className={`label${checkField == 'email' ? ' label-focus' : ''}`}>Email Address</label>
                                <input
                                    type="text"
                                    className="validate"
                                    name="email"
                                    id="email"
                                    placeholder="Company Email Address"
                                    defaultValue={to.email}
                                    onChange={(e) => {
                                        saveForm('to', { email: e.target.value });
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => fieldBlur(e)}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-wrap">
                                <label htmlFor="company" className={`label${checkField == 'company' ? ' label-focus' : ''}`}>Company Name</label>
                                <input
                                    type="text"
                                    className="validate"
                                    name="company"
                                    id="company"
                                    placeholder="Company Name"
                                    defaultValue={to.company}
                                    onChange={(e) => {
                                        saveForm('to', { company: e.target.value });
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => fieldBlur(e)}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-wrap">
                                <label htmlFor="addresstoline1" className={`label${checkField == 'addresstoline1' ? ' label-focus' : ''}`}>Address Line 1</label>
                                <input
                                    type="text"
                                    className="validate"
                                    name="addresstoline1"
                                    id="addresstoline1"
                                    placeholder="Company Address"
                                    defaultValue={to.addresstoline1}
                                    onChange={(e) => {
                                        saveForm('to', { addresstoline1: e.target.value });
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => fieldBlur(e)}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-wrap">
                                <label htmlFor="addresstoline2" className={`label${checkField == 'addresstoline2' ? ' label-focus' : ''}`}>Address Line 2</label>
                                <input
                                    type="text"
                                    className="validate"
                                    name="addresstoline2"
                                    id="addresstoline2"
                                    placeholder="Company City, State, Zip"
                                    defaultValue={to.addresstoline2}
                                    onChange={(e) => {
                                        saveForm('to', { addresstoline2: e.target.value });
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => fieldBlur(e)}
                                />
                            </div>
                        </div>
                    </div>}
                </div>
                <div className="editor-area">
                    <div className="editor-head" onClick={(e) => {
                        //Other than tooltip click
                        matchParentClass(e.target, 'quick-tips', 5) || setIsTabThreeActive(!isTabThreeActive)}
                        
                    }>
                        <div className="editor-title">
                            <div className="title-left">Letter Body <i className="icon-tick-with-circle"  style={summaryTick ? checkedTick : {}}></i> </div>
                            <div className="title-right">
                                {!isTabThreeActive && <div className="quick-tips"><span 
                                className="tips-text" 
                                onClick={()=> { 
                                    setShowToolTip(!showToolTip);
                                    }}>
                                <i className="icon-lightbulb-on"></i>
                                Quick Tips</span>
                                {showToolTip ? <QuickTips section="cover_editor_content" setShowToolTip={(showToolTip) => { setShowToolTip(showToolTip) }} /> : ''}
                                </div>}
                                <i className={isTabThreeActive ? 'icon-arrow icon-arrow-down-light' : 'icon-arrow icon-arrow-up-light'}></i>
                            </div>
                        </div>
                    </div>
                    {!isTabThreeActive && <div className="editor-body">
                        <div className="form-row">
                            <div className="field-wrap field-date">
                                <label htmlFor="start_date" className={`label${checkField == 'start_date' ? ' label-focus' : ''}`}>Letter Date</label>
                                <CalendarIcon />
                                <DatePicker
                                    name="start_date"
                                    className="form-input custom-date-picker"
                                    dateFormat='MM/dd/yyyy'
                                    autoComplete="off"
                                    placeholderText="Letter Date"
                                    maxDate={new Date('2100-01-01')}
                                    selected={summary.date ? new Date(summary.date) : new Date()}
                                    disabledKeyboardNavigation
                                    // value={`${new Intl.DateTimeFormat('en-US').format(new Date(summary.date))}` }
                                    value={summary.date}
                                    onChange={(e) => {
                                        saveForm('summary', { date: e ? `${new Intl.DateTimeFormat('en-US').format(e)}` : '' });
                                        save()
                                        setCheckField('')
                                        // setTimeout(() => markComplete('summary'),4000)
                                    }}
                                    onFocus={(e) => fieldFocus(e)}
                                    onBlur={(e) => setCheckField('')}
                                />
                                <div className={`on-off-btn ${!summary.hide_letter_date ? '':'disabled' }`} >
                                    <span onClick={e =>saveForm('summary', { hide_letter_date: !summary.hide_letter_date })}><i></i></span>
                                    <em className="toggle-text">Show Date</em>
                                </div>
                                {/* {error.end_date && <span style={errorStyle}>{error.end_date}</span>} */}
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-wrap">
                                <label htmlFor="description" className="label">Letter Body</label>
                                <p className="editor-subtitle">Get help writing your bullet points with the pre-written examples below.</p>
                                <div className="rich-text-editor">
                                    {/* <DraftEditor
                        type="text" 
                        className="validate"
                        name="description"
                        id="description" 
                        defaultValue={summary.content}
                        /> */}
                                    <DraftEditor
                                        name="description"
                                        // placeholder="e.g. Dedicated [High School] Teacher with [7] years of experience…"
                                        className="validateee"
                                        textAlignment='left'
                                        value={summary.content}
                                        onInputChange={(val) => {
                                            saveForm('summary', { content: val });
                                        }}
                                        // chatGptButton={true}
                                        showRegenerateButton={true}
                                        // regenerateAction={() => generateBodythruAI()}
                                        regenerateAction={() => {
                                            // update2Preview({},true)
                                            popup.show('cl_content_override', 
                                            null,
                                            () => {
                                                    popup.close('cl_content_override');
                                                    generateBodythruAI();
                                            })
                                        }}
                                        onBlur={() => save()}
                                    // phrasesButton={true}
                                    // colorType="dark-blue"
                                    // showAIPopup={showAIPopup}
                                    // setShowAIPopup={(showAIPopup) => { setShowAIPopup(showAIPopup) }}
                                    // showPhrasePopUp={showPhrasePopUp}
                                    // setShowPhrasePopUp={(showPhrasePopUp) => { setShowPhrasePopUp(showPhrasePopUp) }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    );
}

export default FormSection;